const Footer = () => {

    // const goToTopText = '맨 위로 🔺';
    const footerText = 'This portfolio was created by developer Joonbok Lee';

    return (
        <>
            <div className="footer-container bg-color-thistle">
                {/*<footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">*/}
                <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 border-top">
                    <div className="col-md-4 d-flex align-items-center">
                        <span className="mb-3 mb-md-0 text-body-secondary">{footerText}</span>
                    </div>
                    {/*<ul className="nav col-md-4 justify-content-end list-unstyled d-flex">*/}
                    {/*    <li className="ms-6">*/}
                    {/*        <a className=" no-line-href text-body-secondary" href="#">*/}
                    {/*            {goToTopText}*/}
                    {/*        </a>*/}
                    {/*    </li>*/}
                    {/*</ul>*/}
                </footer>
            </div>
        </>
    )
}
export default Footer;